module.exports = __webpack_public_path__ + "img/btn-bg.900ee5b5.jpg";